export default {
  invites: state => state.invites,
  getInvitesWithHuntAreaId: state => huntAreaId => {
    const invites = state.invites || []
    return invites.filter(invite => invite.huntAreaId === huntAreaId)
  }
}
